import { AircraftCategory } from './aircraft-category';
import { Region } from './region';

export class ServiceArea {
  aircraftCategory: AircraftCategory;
  regions: Array<Region>;
}
